module.exports = __webpack_public_path__ + "static/media/c-indian.c4f4f22c.jpg";